/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizer.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
};

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
   alert('There are now ' + cart.item_count + ' items in the cart.');
  $('#CartCount').text(cart.item_count);
};

ShopifyAPI.updateCartNote = function(note, callback) {
  var params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    alert(data.message + '(' + data.status  + '): ' + data.description);
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: jQuery(form).serialize(),
    dataType: 'json',
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item, form);
      }
      else {
        ShopifyAPI.onItemAdded(line_item, form);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
    }
  };
  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    }
    else {
      ShopifyAPI.onCartUpdate(cart);
    }
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) {
  var params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        var updateUpsells = quantity === 0;
        callback(cart, updateUpsells);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.addItemFromVariantId = function(id, quantity, callback) {
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: {
      items: [
        {
          id: id,
          quantity: quantity,
        }
      ]
    },
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  return jQuery.ajax(params);
};

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {

  'use strict';

  // Public functions
  var init, loadCart;

  // Private general variables
  var settings, isUpdating, $body;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;

  // Private functions
  var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, toggleNotes, validateQty, initToggleUpsells, initUpsellAddToCart, getCartPageUpsells;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {

    // Default settings
    settings = {
      formSelector       : 'form[action^="/cart/add"]',
      cartContainer      : '#CartContainer',
      addToCartSelector  : 'input[type="submit"]',
      cartCountSelector  : '#CartCount',
      cartCostSelector   : null,
      moneyFormat        : '$',
      disableAjaxCart    : false,
      enableQtySelectors : true
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer     = $(settings.formSelector);
    $cartContainer     = $(settings.cartContainer);
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);

    // General Selectors
    $body = $('body');

    // Track cart activity status
    isUpdating = false;

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart && $addToCart.length) {
      formOverride();
    }

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();

    $body.on('ajaxCart.afterCartLoad', toggleNotes);
    toggleNotes();

    if (window.theme.cartUpsells && window.theme.cartUpsells.enabled) {
      $body.on('ajaxCart.afterCartLoad', initToggleUpsells);
      $body.on('ajaxCart.afterCartLoad', initUpsellAddToCart);
    }

    getCartPageUpsells();
  };

  loadCart = function () {
    $body.addClass('drawer--is-loading');
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  updateCountPrice = function (cart) {
    if ($cartCountSelector) {
      // $cartCountSelector.html(cart.item_count).removeClass('hidden-count');
      $cartCountSelector.text(cart.item_count);
      $("#CartCount").text(cart.item_count);

      if (cart.item_count === 1) {
        $("#CartItemsString").text("Item");
      } else {
        $("#CartItemsString").text("Items");
      }

      if (cart.item_count === 0) {
        $cartCountSelector.addClass('hidden-count');
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
    }

  };

  formOverride = function () {
    $formContainer.on('submit', function(evt) {
      evt.preventDefault();

      // Add class to be styled if desired
      $addToCart.removeClass('is-added').addClass('is-adding');

      // Remove any previous quantity errors
      $('.qty-error').remove();

      ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
    });
  };

  window.ajaxAddToCart = function (evt) {
      ShopifyAPI.addItemFromForm(evt, itemAddedCallback, itemErrorCallback);
  };

  itemAddedCallback = function (product) {
    $addToCart.removeClass('is-adding').addClass('is-added');

    

    ShopifyAPI.getCart(cartUpdateCallback);
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeClass('is-adding is-added');

    if (!!data.message) {
      if (data.status == 422) {
        $formContainer.after('<div class="errors qty-error">'+ data.description +'</div>')
      }
    }
  };

  cartUpdateCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);
    buildCart(cart);
  };

  buildCart = function (cart) {
    // Start with a fresh cart div
    $cartContainer.empty();

    // Show empty cart
    if (cart.item_count === 0) {
      $cartContainer.addClass('is-empty');
      cartCallback(cart);
      return;
    } else {
      $cartContainer.removeClass('is-empty');
    }

    // Handlebars.js cart layout
    var items = [],
        item = {},
        data = {},
        source = $("#CartTemplate").html(),
        template = Handlebars.compile(source),
        upsellsHandles = [],
        upsellsHandlesAll = [],
        upsellsProducts = [],
        upsellsMaxProducts = window.theme.cartUpsells.limit ? window.theme.cartUpsells.limit : 0;

        Handlebars.registerHelper('greaterThan', function (v1, v2, options) {
          'use strict';
          if (v1 > v2) {
            return options.fn(this);
          }
          return options.inverse(this);
        });

        Handlebars.registerHelper('equal', function (v1, v2, options) {
            'use strict';
            if (v1 === v2) {
              return options.fn(this);
            }
            return options.inverse(this);
          });

    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {

      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _small, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
      */
      if (cartItem.image != null){
        var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_200x$1").replace('http:', '');
      } else {
        var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }

      if (cartItem.properties !== null) {
        // Get upsells from item properties, remove handle if product is already added to cart
        if (cartItem.properties._upsells) {
          var productUpsells = cartItem.properties._upsells.split(',');
          productUpsells = productUpsells.filter(function(handle){
            var isInCart = cart.items.some(function(item) {
              return item.handle === handle;
            })

            return !isInCart;
          })

          upsellsHandlesAll = upsellsHandlesAll.concat(productUpsells);
        }

        var multibuyBadge = cartItem.properties._multibuy ? cartItem.properties._multibuy : '';

        $.each(cartItem.properties, function(key, value) {
          if (key.charAt(0) === '_' || !value) {
            delete cartItem.properties[key];
          }
        });
      }

      // Create item's data object and add to 'items' array
      item = {
        id: cartItem.variant_id,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: prodImg,
        name: cartItem.product_title,
        variation: cartItem.variant_title,
        properties: cartItem.properties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price: Shopify.formatMoney(cartItem.final_price, settings.moneyFormat),
        totalLinePrice: Shopify.formatMoney(cartItem.price * cartItem.quantity, settings.moneyFormat),
        vendor: cartItem.vendor,
        multibuyBadge: multibuyBadge
      };

      items.push(item);
    });

    if (window.theme.cartUpsells && window.theme.cartUpsells.enabled) {
      var self = this;
      var async_requests = [];

      // Remove duplicates from upsells handles array
      upsellsHandles = Array.from(new Set(upsellsHandlesAll));

      if (upsellsHandles.length > 0) {
        upsellsHandles.forEach(function(upsellHandle, index) {
          // check sessionStorage to see if we already have this product
          var upsellsProduct = sessionStorage.getItem('__upsell:' + upsellHandle);
          if (upsellsProduct) {
            var upsellsProductData = JSON.parse(upsellsProduct);
            if (upsellsProductData.available) {
              upsellsProducts.push(upsellsProductData);
            } else {
              upsellsHandles.splice(index, 1);
            }
            return;
          }

          // If product is not in session storage, get it via AJAX
          // async_requests variable groups all requests so we can detect
          // when all have completed and update the ajax cart template
          async_requests.push($.ajax({
            type: 'GET',
            url: '/products/' + upsellHandle + '.js',
            dataType: 'json'
          }).done(function(response){
            var selected_variant = response.variants.find(function(variant) {
              return variant.available;
            });

            var sizeOptionIndex = response.options.findIndex(function(option){
              return option.name.toLowerCase() === 'size'
            });

            const variants_data = response.variants.map(function(variant){
              return {
                id: variant.id,
                title: variant.options[sizeOptionIndex],
                available: variant.available
              }
            });

            var upsellsProductData = {
              id: response.id,
              title: response.title,
              available: response.available,
              url: response.url,
              image: response.featured_image.replace(/(\.[^.]*)$/, "_200x$1").replace("http:", ""),
              price: Shopify.formatMoney(response.price, settings.moneyFormat),
              compareAtPrice: Shopify.formatMoney(response.compare_at_price, settings.moneyFormat),
              priceVaries: response.price_varies,
              variants: variants_data,
              selected_variant: selected_variant ? selected_variant.id : ''
            }

            if (upsellsProductData.available) {
              upsellsProducts.push(upsellsProductData);
            } else {
              upsellsHandles.splice(index, 1);
            }

            sessionStorage.setItem('__upsell:' + upsellHandle, JSON.stringify(upsellsProductData));
          }));
        });
      }

      // Get remaining upsell products using the product recommendations API
      if (upsellsHandles.length < upsellsMaxProducts) {
        var lastAddedProduct = cart.items[0];
        var productHandle = lastAddedProduct.handle;
        var productId = lastAddedProduct.product_id;
        var limit = upsellsMaxProducts - upsellsHandles.length;

        // first check sessionStorage to see if we already have this product
        var upsellsRecommendations = sessionStorage.getItem('__recommendations:' + productHandle);

        if (upsellsRecommendations) {
          upsellsRecommendations = JSON.parse(upsellsRecommendations);

          // remove any products that are already in the cart or in the upsells section
          upsellsRecommendations = upsellsRecommendations.filter(function(recommendationsItem) {
            var isInCart = cart.items.some(function(item){
              return item.handle === recommendationsItem.handle
            });

            var isInUpsells = upsellsHandles.some(function(upsellHandle){
              return upsellHandle === recommendationsItem.handle
            });

            if (isInCart || isInUpsells || !recommendationsItem.available) {
              return false;
            }

            return true;
          });

          upsellsProducts = upsellsProducts.concat(upsellsRecommendations.slice(0, limit));

        } else {
          upsellsRecommendations = [];

          async_requests.push($.ajax({
            type: 'GET',
            url: '/recommendations/products.json?product_id=' + productId +'&limit=10',
            dataType: 'json'
          }).done(function(response){
            upsellsRecommendations = response.products.map(function(product) {
              // remove any products that are already in the cart or in the upsells section or not available
              var isInCart = cart.items.some(function(item){
                return item.handle === product.handle
              });

              var isInUpsells = upsellsHandles.some(function(upsellHandle){
                return upsellHandle === product.handle
              });

              if (isInCart || isInUpsells || !product.available) {
                return false;
              }

              var selected_variant = product.variants.find(function(variant) {
                return variant.available;
              });

              var sizeOptionIndex = product.options.findIndex(function(option){
                return option.name.toLowerCase() === 'size'
              });

              const variants_data = product.variants.map(function(variant){
                return {
                  id: variant.id,
                  title: variant.options[sizeOptionIndex],
                  available: variant.available
                }
              });

              return {
                id: product.id,
                title: product.title,
                available: product.available,
                url: product.url,
                image: product.featured_image ? product.featured_image.replace(/(\.[^.]*)$/, "_200x$1").replace("http:", "") : '',
                price: Shopify.formatMoney(product.price, settings.moneyFormat),
                compareAtPrice: Shopify.formatMoney(product.compare_at_price, settings.moneyFormat),
                priceVaries: product.price_varies,
                variants: variants_data,
                selected_variant: selected_variant ? selected_variant.id : ''
              }
            });

            sessionStorage.setItem('__recommendations:' + productHandle, JSON.stringify(upsellsRecommendations));

            upsellsProducts = upsellsProducts.concat(upsellsRecommendations.slice(0, limit));
          }));
        }
      }

      // We got all the upsell products with AJAX, update ajax cart template
      if (async_requests.length > 0) {
        $.when.apply(null, async_requests).done( function(){
          data.upsells = upsellsProducts;

          $cartContainer.html(template(data));

          cartCallback(cart);
        });
      }
    }

    // Gather all cart data and add to DOM
    data = {
      items: items,
      upsells: upsellsProducts,
      autoExpandUpsells: document.querySelector(settings.cartContainer).dataset.autoExpandUpsells === 'true',
      note: cart.note,
      totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat),
      freeShippingDifference: window.theme.freeShippingThreshold > (cart.total_price / 100) ? Shopify.formatMoney((window.theme.freeShippingThreshold * 100) - cart.total_price) : 'nope',
      freeShipping: (cart.total_price / 100) >= window.theme.freeShippingThreshold,
    }

    $cartContainer.append(template(data));

    cartCallback(cart);
  };

  cartCallback = function(cart) {
    $body.removeClass('drawer--is-loading');
    $body.trigger('ajaxCart.afterCartLoad', cart);
  };

  adjustCart = function () {
    // Delegate all events because elements reload with the cart

    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-adjust', function() {
      var $el = $(this),
          line = $el.data('line'),
          $qtySelector = $el.siblings('.ajaxcart__qty-num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    });

    // Remove item
    $body.on('click', '.ajaxcart__remove', function() {
      var $el = $(this),
          line = $el.data('line'),
          $qtySelector = $el.siblings('.ajaxcart__qty-num'),
          qty = 0;

      var qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    });

    // Update quantity based on input on change
    $body.on('change', '.ajaxcart__qty-num', function() {
      var $el = $(this),
          line = $el.data('line'),
          qty = parseInt($el.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty);
      }
    });

    // Prevent cart from being submitted while quantities are changing
    $body.on('submit', 'form.ajaxcart', function(evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });

    function updateQuantity(line, qty) {
      isUpdating = true;

      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

      // Slight delay to make sure removed animation is done
      setTimeout(function() {
        ShopifyAPI.changeItem(line, qty, adjustCartCallback);
      }, 250);
    }

    // Save note anytime it's changed
    $body.on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function(cart) {});
    });
  };

  adjustCartCallback = function (cart, updateUpsells = false) {
    isUpdating = false;

    // Update quantity and price
    updateCountPrice(cart);

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function() {
      ShopifyAPI.getCart(buildCart);
    }, 150)

    // Update upsells on cart page; this should be triggered only when a product is removed
    if (updateUpsells) {
      getCartPageUpsells();
    }
  };

  createQtySelectors = function() {
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function() {
        var $el = $(this),
            currentQty = $el.val();

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#AjaxQty").html(),
            template = Handlebars.compile(source),
            data = {
              id: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });
    }
  };

  qtySelectors = function() {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('input[type="number"]');

    if (numInputs.length) {
      numInputs.each(function() {
        var $el = $(this),
            currentQty = $el.val(),
            inputName = $el.attr('name'),
            inputId = $el.attr('id');

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#JsQty").html(),
            template = Handlebars.compile(source),
            data = {
              id: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus,
              inputName: inputName,
              inputId: inputId
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });

      // Setup listeners to add/subtract from the input
      $('.js-qty__adjust').on('click', function() {
        var $el = $(this),
            id = $el.data('id'),
            $qtySelector = $el.siblings('.js-qty__num'),
            qty = parseInt($qtySelector.val().replace(/\D/g, ''));

        var qty = validateQty(qty);

        // Add or subtract from the current quantity
        if ($el.hasClass('js-qty__adjust--plus')) {
          qty += 1;
        } else {
          qty -= 1;
          if (qty <= 1) qty = 1;
        }

        // Update the input's number
        $qtySelector.val(qty);
      });
    }
  };

  toggleNotes = function (event) {
    $('.js-notes-toggle').on('click', function(e) {
      e.preventDefault();
      $(this).toggleClass('is-active');
      $('.notes-panel').toggleClass('is-shown');
    });
  };

  validateQty = function (qty) {
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };

  initToggleUpsells = function (event) {
    var cartUpsellsToggle = document.querySelector('.cart__upsells-toggle');
    var cartUpsellsPanel = document.getElementById('CartUpsells');

    var cartDrawer = document.getElementById('CartDrawer');

    if (!cartUpsellsToggle || !cartUpsellsPanel) return;

    var isExpanded = cartUpsellsToggle.ariaExpanded === 'true';

    cartUpsellsToggle.addEventListener('click', function(e) {
      e.preventDefault();
      isExpanded = !isExpanded;
      cartUpsellsToggle.setAttribute('aria-expanded', isExpanded);
      cartUpsellsPanel.setAttribute('aria-hidden', !isExpanded);

      if (!isExpanded) return;

      cartDrawer.scrollTo({
        top: cartUpsellsPanel.offsetTop - 120,
        behavior: 'smooth'
      });
    });
  };

  initUpsellAddToCart = function() {
    var upsellContainer = document.getElementById('CartUpsells');
    if (!upsellContainer) {
      return;
    }
    var upsellItems =  upsellContainer.querySelectorAll('.product-item');
    if (upsellItems.length > 0) {
      upsellItems.forEach(function(item) {
        const selectedInput = item.querySelector('.product-item__variant:checked');
        const addToCartBtn = item.querySelector('[data-upsell-add]');
        if (!selectedInput || !addToCartBtn) {
          return;
        }

        addToCartBtn.addEventListener('click', function(e) {
          e.preventDefault();
          var variantId = Number(selectedInput.value);
          ShopifyAPI.addItemFromVariantId(variantId, 1, adjustCartCallback);
        })
      })
    }
  };

  getCartPageUpsells = function (){
    var upsellsSection = document.querySelector('.you-may-also-like');
    const upsellsSlider = document.querySelector('.you-may-also-like__slider');
    if (!upsellsSection || !upsellsSlider) return;

    if (upsellsSection.dataset.recommendationsEnable === 'false') {
      upsellsSection.classList.remove('hide');

      $('.you-may-also-like__slider').slick({
        dots: false,
        arrows: true,
        infinite: false,
        slidesToShow: 1.5,
        slidesToScroll: 1,
        mobileFirst: true,
        responsive: [
          {
            breakpoint: 1070,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 5
            }
          },
          {
            breakpoint: 940,
            settings: {
              slidesToShow: 4.5,
              slidesToScroll: 4
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3.5,
              slidesToScroll: 3
            }
          },
          {
            breakpoint: 500,
            settings: {
              slidesToShow: 2.5,
              slidesToScroll: 2
            }
          }
        ]
      });

      return;
    }

    var sectionId = upsellsSection.dataset.sectionId;
    var productId = upsellsSection.dataset.productId;
    var baseUrl = upsellsSection.dataset.url;
    var upsellsMaxProducts = Number(upsellsSection.dataset.productsLimit);

    var url = baseUrl + '?section_id='+ sectionId +'&limit=' + upsellsMaxProducts +'&product_id=' + productId;

    $.get(url).then(function(response) {
      var container = document.createElement("div");
      container.innerHTML = response;

      var slider = container.querySelector('.you-may-also-like__slider');
      var gridItemsArray = Array.from(container.querySelectorAll('.grid__item'));
      var cartItemsArray = Array.from(document.querySelectorAll('.cart__row'));

      var gridItemsUnique = gridItemsArray.filter(function(gridItem, index, gridItemsArray) {
        const isUnique = gridItemsArray.findIndex(item => (item.dataset.productHandle === gridItem.dataset.productHandle)) === index;

        const isInCart = cartItemsArray.some(function(cartItem){
          return cartItem.dataset.productHandle === gridItem.dataset.productHandle
        });

        return isUnique && !isInCart;
      });

      // keep just the first items as defined in upsellsMaxProducts
      var gridItemsDisplay = gridItemsUnique.slice(0, upsellsMaxProducts);
      slider.innerHTML = '';

      gridItemsDisplay.forEach(function(gridItem) {
        slider.innerHTML += gridItem.outerHTML;
      })

      upsellsSection.innerHTML = container.querySelector('.you-may-also-like').innerHTML;

      upsellsSection.classList.remove('hide');

      $('.you-may-also-like__slider').slick({
        dots: false,
        arrows: true,
        infinite: false,
        slidesToShow: 1.5,
        slidesToScroll: 1,
        mobileFirst: true,
        responsive: [
          {
            breakpoint: 1070,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 5
            }
          },
          {
            breakpoint: 940,
            settings: {
              slidesToShow: 4.5,
              slidesToScroll: 4
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3.5,
              slidesToScroll: 3
            }
          },
          {
            breakpoint: 500,
            settings: {
              slidesToShow: 2.5,
              slidesToScroll: 2
            }
          }
        ]
      });
    });
  };

  module = {
    init: init,
    load: loadCart
  };

  return module;

}(ajaxCart || {}, jQuery));
